import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ThunkAction } from 'redux-thunk';
import { QueueCallback } from '~redux/queue';
import { RootState } from '~redux/reducer';

export const useThunkQueue = (key: string) => {
  const dispatch = useDispatch();
  const [isProcessing, setIsProcessing] = useState(false);
  const queue = useCallback(
    (fn: ThunkAction<Promise<any>, RootState, any, any>) => {
      dispatch({
        queue: key,
        callback: (async (next, dispatch, getState, extrArgument) => {
          setIsProcessing(true);
          await fn(dispatch, getState, extrArgument);
          setIsProcessing(false);
          next();
        }) as QueueCallback<any>,
      });
    },
    [key]
  );

  return {
    queue,
    isProcessing,
  };
};
